import { isMediaMatch } from "utils-lib/styles"
import { MEDIA_QUERY_LG_MIN } from "constants-lib/dimensions"

const renditionPath = `/jcr:content/renditions/rendition.`

/**
 * Returns the srcset attribute value for an image.
 * @function
 * @param {string} src - The source URL of the image.
 * @param {number} size - The size of the image.
 * @param {boolean} disableRendition - Whether to disable the use of renditions.
 * @param {boolean} useAltRendition - Whether to use an alternative rendition path.
 * @param {string} altRenditionPath - The alternative rendition path to use.
 * @returns {string} The srcset attribute value for the image.
 */
export const getSrcSet = (
  src,
  size,
  disableRendition,
  useAltRendition,
  altRenditionPath,
) => {
  if (
    !size ||
    disableRendition ||
    src?.indexOf(`.svg`) !== -1 ||
    src?.indexOf(`.png`) !== -1
  ) {
    return src
  }

  const chosenRenditionPath =
    useAltRendition && isMediaMatch(MEDIA_QUERY_LG_MIN)
      ? altRenditionPath
      : renditionPath

  return `${src}${chosenRenditionPath}${size}.jpeg`
}
